import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  ContentDatePipe,
  ContentTitleImagePipe,
  HasTitleImagePipe,
  IPublishedNews,
  ImmomioIconName,
} from '@resident-nx/shared';
import { AsyncPipe, DatePipe } from '@angular/common';
import { IconWebComponent } from '@resident-nx/web/ui';
import { LabelWebComponent } from '../../atoms/label/label.component';
import { PictureWebComponent } from '../../atoms/picture/picture.component';

@Component({
  standalone: true,
  selector: 'rs-web-news-card',
  templateUrl: './news-card.component.html',
  styleUrls: ['./news-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PictureWebComponent,
    LabelWebComponent,
    IconWebComponent,
    DatePipe,
    AsyncPipe,
    ContentTitleImagePipe,
    HasTitleImagePipe,
    ContentDatePipe,
  ],
})
export class NewsCardWebComponent {
  @Input() item: IPublishedNews;
  public immomioIconName = ImmomioIconName;
}
